import styled from '@emotion/styled';
import AquillaPrimeBottomBanner from 'aquilla/core/molecules/Prime Bottom Banner';
import PropTypes from 'prop-types';
import pushRoute from '@utils/pushRoute';

const plusBannerGradient = `
  linear-gradient(180deg, var(--color-i-plus-banner-start) 0%, var(--color-green-3) 100%)
`;

const BannerWrapper = styled.div`
  position: fixed;
  right: max(24px, calc((100vw - 1136px) / 2));
  bottom: 24px;
  left: max(24px, calc((100vw - 1136px) / 2 + 288px));
  z-index: 10;
  display: flex;
  width: auto;
  box-sizing: border-box;
  pointer-events: none;

  & .aquilla-prime-banner-action,
  & .aquilla-join-prime-button {
    color: var(--color-green-3);
  }

  & > .aquilla-prime-banner {
    width: 100%;
    pointer-events: auto;
    background: ${plusBannerGradient};
  }

  @media screen and (max-width: 768px) {
    right: 16px;
    bottom: 16px;
    left: 16px;
  }
`;

const TestTabPlusStickyBanner = ({ goalSlug, goalUID, onGetPlus }) => (
  <BannerWrapper>
    <AquillaPrimeBottomBanner
      title="Get access to all the tests"
      subtitle={null}
      buttonLabel="Get Plus"
      onButtonClick={() => {
        onGetPlus?.();
        pushRoute(`/goal/${goalSlug}/${goalUID}/subscriptions`);
      }}
    />
  </BannerWrapper>
);

export default TestTabPlusStickyBanner;

TestTabPlusStickyBanner.propTypes = {
  goalSlug: PropTypes.string.isRequired,
  goalUID: PropTypes.string.isRequired,
  onGetPlus: PropTypes.func
};
